import React, { useEffect, useRef, useState } from "react";

import { useField } from "formik";

import Field from "./index";

export default function File({
  accept,
  appActions,
  helperText,
  maxFiles,
  maxSize,
  multiple,
  name = "file",
  value,
  ...props
}) {
  const [warn, setWarn] = useState(false);
  const [, meta, helpers] = useField(name);
  const ref = useRef();

  useEffect(() => {
    const input =
      ref.current && ref.current.querySelector('input[type="file"]');
    if (input.files.length && meta.error) {
      input.value = null;
    }
  }, [meta.error]);

  if (maxFiles || maxSize) {
    let maxText = `Max ${maxFiles ? `${maxFiles} files` : ""} ${
      maxFiles && maxSize ? "and " : ""
    }${maxSize ? `${maxSize}mb per file` : ""}`;
    helperText = helperText ? (
      <React.Fragment>
        {helperText}
        <br />
        {maxText}
      </React.Fragment>
    ) : (
      maxText
    );
  }

  const InputLabelProps = {
    shrink: true,
  };

  const inputProps = {
    accept,
    multiple,
  };

  function handleChange(e) {
    const { files } = e.currentTarget;
    let warn = false;

    if (multiple && maxFiles && files.length > maxFiles) {
      warn = true;
    } else if (maxSize) {
      warn = Array.from(files).some(
        (file) => file.size > maxSize * 1024 * 1024
      );
    }

    setWarn(warn);
    if (warn) {
      e.currentTarget.value = null;
      helpers.setValue(multiple ? [] : null, false);
    } else {
      helpers.setValue(multiple ? files : files[0], false);
    }
  }

  return (
    <Field
      helperText={helperText}
      innerRef={ref}
      InputLabelProps={InputLabelProps}
      inputProps={inputProps}
      name={name}
      type="file"
      warn={warn}
      value={undefined}
      onChange={handleChange}
      {...props}
    />
  );
}
